/**
 * USA flag SVG — simplified, clean rendition.
 * 13 stripes (7 red + 6 white), blue canton with 50 stars (5x6 + 4x5).
 */
export default function UsFlag({ className = 'w-48 h-auto' }: { className?: string }) {
  const stripeHeight = 100 / 13
  const stripes = Array.from({ length: 13 }, (_, i) => ({
    y: i * stripeHeight,
    color: i % 2 === 0 ? '#B22234' : '#FFFFFF'
  }))

  // Canton: 7 stripes tall × 40% wide (official ratio)
  const cantonH = stripeHeight * 7
  const cantonW = 76  // 40% of 190 viewBox width

  // 50 stars: 9 rows alternating 6 and 5 stars
  const starRows: { cx: number; cy: number }[] = []
  for (let row = 0; row < 9; row++) {
    const isLongRow = row % 2 === 0  // 6 stars (even) or 5 (odd)
    const count = isLongRow ? 6 : 5
    const rowY = (cantonH / 10) * (row + 1)
    const offset = isLongRow ? 0 : cantonW / 12
    const spacing = cantonW / (isLongRow ? 6 : 5)
    for (let col = 0; col < count; col++) {
      starRows.push({
        cx: spacing / 2 + col * spacing + offset,
        cy: rowY
      })
    }
  }

  return (
    <svg viewBox="0 0 190 100" className={className} role="img" aria-label="US flag">
      {stripes.map((s, i) => (
        <rect key={i} x="0" y={s.y} width="190" height={stripeHeight} fill={s.color} />
      ))}
      {/* Canton */}
      <rect x="0" y="0" width={cantonW} height={cantonH} fill="#3C3B6E" />
      {/* Stars (small filled circles approximate, simple & legible) */}
      {starRows.map((st, i) => (
        <circle key={i} cx={st.cx} cy={st.cy} r="1.3" fill="#FFFFFF" />
      ))}
      {/* Outer border */}
      <rect x="0" y="0" width="190" height="100" fill="none" stroke="#00000022" strokeWidth="0.5" />
    </svg>
  )
}
